import dateFormat, { masks } from "dateformat";
import constants from "../constants";
import utils from "../utils";
import Class from "./Class";

export default class Subject {
    constructor(data = {}) {
        this.name = data.name || ""
        this.description = data.description || ''
        this.id = data.subjectId || null

        // those attribute is for filter
        this.text = this.name
        this.value = this.id

    }
}